<app-navbar>
  <app-user-action></app-user-action>
</app-navbar>
<div class="page-layout">
  <app-sidebar></app-sidebar>
  <div class="main-content">
    <div class="ui container favorite-content">
      <div class="toolbar">
        <div class="filter-group">
          <label>状态:</label>
          <select [(ngModel)]="selectedStatus" (ngModelChange)="onStatusChange()">
            @for (opt of statusOptions; track opt) {
              <option [value]="opt.value">{{opt.label}}</option>
            }
          </select>
        </div>
        <div class="filter-group">
          <label>排序:</label>
          <select [(ngModel)]="orderBy" (ngModelChange)="onSortChange()">
            @for (opt of sortFieldOptions; track opt) {
              <option [value]="opt.value">{{opt.label}}</option>
            }
          </select>
          <select [(ngModel)]="sort" (ngModelChange)="onSortChange()">
            @for (opt of sortDirectionOptions; track opt) {
              <option [value]="opt.value">{{opt.label}}</option>
            }
          </select>
        </div>
      </div>
      @if (favorites.length > 0) {
        <div class="ui six doubling cards">
          @for (fav of favorites; track fav) {
            <div class="card item-card">
              <a class="image" [routerLink]="['/item', fav.item.id]">
                @if (fav.item.coverImage) {
                  <ui-responsive-image [src]="fav.item.coverImage.url"
                               [size]="{
                                      width: '100%',
                                      ratio: 1.405152224824,
                                      originalWidth: fav.item.coverImage.width,
                                      originalHeight: fav.item.coverImage.height}"
                  [background]="fav.item.coverImage.dormantColor"></ui-responsive-image>
                }
              </a>
              <a class="content" [routerLink]="['/item', fav.item.id]">
                <span>{{fav.item.nameCn || fav.item.name || ' '}}</span>
              </a>
            </div>
          }
        </div>
      }
      @if (favorites.length === 0) {
        <div class="empty-tip">
          <p>暂无收藏</p>
        </div>
      }
      @if (total > pageSize) {
        <div class="pagination-wrapper">
          <ui-pagination
            [currentPage]="currentPage"
            [total]="total"
            [countPerPage]="pageSize"
            [max]="5"
            (pageChange)="onPageChange($event)">
          </ui-pagination>
        </div>
      }
    </div>
  </div>
</div>
